import { mergeWith } from "lodash-es";
class MockFactory {
  constructor(source) {
    this.source = source;
  }
  build(newSource, config = {
    mergeArray: true,
    mergeObject: true
  }) {
    return mergeWith(
      { ...this.source },
      newSource,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (value, srcValue) => {
        if (Array.isArray(value) && !config.mergeArray) {
          return srcValue;
        }
        if (typeof value === "object" && !config.mergeObject) {
          return srcValue;
        }
      }
    );
  }
}
export {
  MockFactory
};
//# sourceMappingURL=mock.factory.js.map
